import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=704ee099&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=ts"
export * from "./activityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ee099",
  null
  
)

export default component.exports